import { Check } from '@mui/icons-material';
import { ListItemText, MenuItem, Select, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import { removeCookie } from '../../hooks/useCookie';
import { setCode, clearLocalStorage } from '../../hooks/useLocalStorage';

const MobileDropDownMenu = ({
  numbers,
  additionalStyles,
  changeOfferJourney,
  subscriptionId,
  // disableAltcta,
}) => {
  const theme = useTheme();
  const [selectedNumber, setSelectedNumber] = useState(additionalStyles ? '' : 'Choose a number');
  const [isOpen, setIsOpen] = useState(false);

  const handleSelectChange = event => {
    const number = event?.target?.value;
    if (number !== 'Get a new plan') {
      setSelectedNumber(number);
      const data = numbers.find(item => item.msisdn === number);
      changeOfferJourney(data?.value);
    } else {
      removeCookie('subscription_id');
      removeCookie('cart_Type');
      removeCookie('reference');
      setCode('CO');
      clearLocalStorage();
      changeOfferJourney();
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (subscriptionId) {
      const data = numbers.find(item => item.value === parseInt(subscriptionId, 10));
      setSelectedNumber(data?.msisdn);
    }
  }, [subscriptionId, numbers]);

  return (
    <Select
      // variant='body1'
      value={selectedNumber}
      onChange={handleSelectChange}
      onOpen={handleOpen}
      onClose={handleClose}
      open={isOpen}
      renderValue={selected => selected}
      MenuProps={{
        PaperProps: {
          sx: {
            marginTop: '4px',
            boxShadow: `0px 2px 4px -1px ${theme.palette.primary.boxShadow}, 0px 4px 5px ${theme.palette.primary.boxShadow}, 0px 1px 10px ${theme.palette.primary.boxShadow}`,
          },
        },
      }}
      sx={additionalStyles ? styles(theme).container : styles(theme).selectContainer}
    >
      {numbers?.map(number => (
        <MenuItem
          key={number.value}
          value={number.msisdn}
          onClick={number.onClick}
          disabled={!number.changeOffer}
          sx={styles(theme).menuItems}
        >
          <ListItemText primary={number.msisdn} />
          {isOpen && selectedNumber === number.msisdn && (
            <Check sx={{ color: theme.palette.secondary.greenBackground }} />
          )}
        </MenuItem>
      ))}
      <MenuItem value={additionalStyles ? 'Get a new plan' : 'Choose a number'}>
        <Typography variant='caption' sx={styles(theme).defaultMenuItem}>
          {additionalStyles ? 'Get a new plan' : 'Choose a number'}
        </Typography>
      </MenuItem>
    </Select>
  );
};

export default MobileDropDownMenu;
